import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BookOpen, MessageSquare, GraduationCap, Trophy, Sparkles, ArrowRight, Flame } from "lucide-react";

const CARDS = [
  { to: "/konular", title: "Konu Anlatımı", desc: "Nokta Öğretmen'den ders al", icon: BookOpen, color: "bg-blue-500", soft: "bg-blue-50" },
  { to: "/soru-cevap", title: "Soru-Cevap", desc: "Aklına takılanı sor", icon: MessageSquare, color: "bg-rose-500", soft: "bg-rose-50" },
  { to: "/denemeler", title: "Deneme Sınavı", desc: "Kendini sınavlarla dene", icon: GraduationCap, color: "bg-emerald-500", soft: "bg-emerald-50" },
  { to: "/ilerleme", title: "İlerleme Takibi", desc: "Başarını takip et", icon: Trophy, color: "bg-amber-500", soft: "bg-amber-50" },
];

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/progress").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-indigo-600 to-indigo-500 rounded-3xl p-6 sm:p-8 text-white animate-float-up">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <p className="text-indigo-100 text-sm font-medium">Merhaba,</p>
            <h1 className="font-display text-2xl sm:text-3xl font-bold">{user?.name}! 👋</h1>
            <p className="mt-2 text-indigo-100 text-sm max-w-md">
              {user?.is_subscribed ? "Bugün hangi konuyu öğrenmek istersin?" : "Premium ile tüm derslerin kilidini aç!"}
            </p>
          </div>
          {!user?.is_subscribed && (
            <Link to="/abonelik" data-testid="dashboard-premium-btn" className="bg-amber-400 hover:bg-amber-300 text-amber-900 font-bold px-5 py-3 rounded-2xl flex items-center gap-2">
              <Sparkles className="w-5 h-5" /> Premium Ol
            </Link>
          )}
        </div>
      </div>

      {stats && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <Stat label="Tamamlanan Konu" value={`${stats.topics_completed}/${stats.topics_total}`} icon={BookOpen} color="text-blue-600" />
          <Stat label="Çözülen Deneme" value={stats.exams_taken} icon={GraduationCap} color="text-emerald-600" />
          <Stat label="Ortalama Başarı" value={`%${stats.avg_score}`} icon={Trophy} color="text-amber-600" />
          <Stat label="Motivasyon" value="Harikasın! 🔥" icon={Flame} color="text-rose-600" />
        </div>
      )}

      <div>
        <h2 className="font-display text-xl font-bold text-slate-900 mb-4">Modüller</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {CARDS.map((c, i) => (
            <Link key={c.to} to={c.to} data-testid={`module-${c.to.slice(1)}`}
              className="group bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all animate-float-up"
              style={{ animationDelay: `${i * 70}ms` }}>
              <div className="flex items-center gap-4">
                <div className={`${c.color} w-14 h-14 rounded-2xl flex items-center justify-center text-white`}>
                  <c.icon className="w-7 h-7" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-lg text-slate-900">{c.title}</h3>
                  <p className="text-sm text-slate-500">{c.desc}</p>
                </div>
                <ArrowRight className="w-5 h-5 text-slate-300 group-hover:text-indigo-500 group-hover:translate-x-1 transition" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, icon: Icon, color }) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm">
      <Icon className={`w-6 h-6 ${color}`} />
      <p className="mt-2 text-xl font-extrabold text-slate-900">{value}</p>
      <p className="text-xs text-slate-500 font-medium">{label}</p>
    </div>
  );
}
